import {createAction} from "@reduxjs/toolkit";
import {SettlementSearchCriteria} from "@ots-frontend/ots-data";

export const setUISettlementSearchFilter = createAction<SettlementSearchCriteria>("ots-ui/settlement/setSearchFilter");
